import WhatsappIcon from "assets/images/SupportAndChat/WhatsappIcon.png";
import Button from "components/common/Button";
import { BiLogoWhatsapp } from "react-icons/bi";


const ForWhatsapp: React.FC<{ toggle: () => void }> = ({ toggle }) => {
    return (<>
        <div className="py-10 flex flex-col h-full items-center justify-center">
            <img
                className="mb-7"
                src={WhatsappIcon}
                alt="Icon" />

            <p className="font-[400] text-[16px] text-dark0b mb-3">Hi, send us a WhatsApp message today.</p>

            <div className="lg:w-[50%] flex flex-col items-center justify-center">
                <p className="mb-10 text-center font-[400] text-[14px] text-textGrey/70">
                    Reach out to us today with any complaints or suggestions on how we can improve. Send an email to <span className="text-danger">Quivatransfers@gmail.com</span> or use the button below to contact us directly.
                </p>
                <Button buttonType="primary" size="md" className="!flex items-center"><BiLogoWhatsapp className="mr-2" /> 08129445935</Button>
            </div>


        </div>
    </>);
}

export default ForWhatsapp;